/**
 *  @file       at-exit.js
 *  @author     Wes Garland, wes@distributive.network
 *  @date       Oct 2022
 */
'use strict';

/**
 * Analogue of POSIX atexit(2). Invokes a function when the process is exiting.
 * Ideally, this is what process.on('exit') would do, but it doesn't fire in
 * the case of default signal handlers.
 */
exports.atExit = function shutdown$$atExit(fn)
{
  require('../node-libs/signal-handler').init();
  process.on('dcpExit', fn);
}

exports.atExitCancel = function shutdown$$atExit(fn)
{
  process.off('dcpExit', fn);
}
